import { Youtube, Facebook, Instagram } from "lucide-react";

const TikTok = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.61c.27 0 .53.04.77.12V9.77a5.7 5.7 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.24-1.48z" />
  </svg>
);

export const SOCIALS = [
  { name: "YouTube", handle: "@queenboyce7974", href: "https://www.youtube.com/@queenboyce7974", icon: Youtube },
  { name: "TikTok", handle: "@queen.boyce8", href: "https://www.tiktok.com/@queen.boyce8", icon: TikTok },
  { name: "Facebook", handle: "queen2669669", href: "https://www.facebook.com/queen2669669", icon: Facebook },
  { name: "Instagram", handle: "@queenboyce2", href: "https://www.instagram.com/queenboyce2/", icon: Instagram },
];

export const SocialLinks = () => (
  <div data-testid="social-links">
    <p className="eyebrow">Follow my journey</p>
    <div className="flex flex-wrap gap-3 mt-4">
      {SOCIALS.map(({ name, handle, href, icon: Icon }) => (
        <a key={name} href={href} target="_blank" rel="noopener noreferrer" data-testid={`social-link-${name.toLowerCase()}`}
          className="glass card-hover rounded-full pl-3 pr-5 py-2 inline-flex items-center gap-3 text-sm text-[#f7f1e1]/90 hover:text-[#f1d57a]">
          <span className="w-8 h-8 rounded-full border border-[#d4af37]/50 flex items-center justify-center text-gold"><Icon size={16} /></span>
          <span><span className="font-cinzel text-xs tracking-widest uppercase block text-[#f1d57a]">{name}</span>{handle}</span>
        </a>
      ))}
    </div>
  </div>
);
